import axios from 'axios';

import {BASE_API_URL} from '@/config.js';

class ImportApi {
  async stashReference (reference) {
    try {
      const response = await axios.post(BASE_API_URL + '/import/stash/json', {importStr: JSON.stringify([{sourceId: reference.sourceId, urlToImage: reference.urlToImage, metadata: reference.metadata}])});
      return response.data.token;
    } catch (error) {
    }
  }
}

const singleton = new ImportApi();
export default singleton;



// WEBPACK FOOTER //
// ./src/services/importApi.js